import React, { Component } from 'react';

import { Api } from '../../lib/api';
import './styles.css';

class AboutPage extends Component {
    state = {
        version: '',
        password: '',
        advanceVisible: false,
        ip: null,
        size: null
    };

    componentDidMount() {
        Api.getVersion().then((version) => this.setState({ version: version }));
        Api.getIp().then((ip) => this.setState({ ip: ip }));
        Api.getSize().then((size) => this.setState({ size: size }));
    }

    render() {
        return (
            <div id="about-page">
                <div className="section">
                    <div className="header">XNS Information</div>
                    <div className="body">
                        <div className="img-div">
                            <img src="/images/client-1.png" alt="server" />
                        </div>
                        <div className="content">
                            <div>
                                <span style={{ fontWeight: 'bold' }}>IP: </span>
                                {this.state.ip}:8083
                            </div>
                            <div>
                                <span style={{ fontWeight: 'bold' }}>Version: </span>
                                {this.state.version}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="header">Database Information</div>
                    <div className="body">
                        <div className="img-div">
                            <img src="/images/cloud-database-1.png" alt="database" />
                        </div>
                        <div className="content">
                            <div>
                                <span style={{ fontWeight: 'bold' }}>Status: </span>{' '}
                                <span style={{ color: '#232F45' }}>Connected</span>
                            </div>
                            <div>
                                <span style={{ fontWeight: 'bold' }}>Size: </span>{' '}
                                <span style={{ color: '#232F45' }}>{this.state.size} GB</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="header">Technical Support Contact</div>
                    <div className="body">
                        <div className="img-div">
                            <img src="/images/support.png" alt="support" />
                        </div>
                        <div className="content">
                            <div>
                                <a href="mailto: support.inst@santec.com">
                                    {' '}
                                    <img className="small-img" src="/images/email-1.png" alt="support" />
                                    support.inst@santec.com
                                </a>
                            </div>
                            <div>
                                <img className="small-img" src="/images/phone-1.png" alt="support" />
                                &nbsp; +1 (613) 599-1000
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="header">Remote Access Support</div>
                    <div className="body">
                        <div className="img-div">
                            <img src="/images/teamviewer-1.png" alt="team viewer" />
                        </div>
                        <div className="content">
                            <div>
                                Please download and install{' '}
                                <a href="https://get.teamviewer.com/santecCanada" target="_blank" rel="noreferrer noopener">
                                    TeamViewer
                                </a>
                            </div>
                            <div>
                                Send the user ID and the password to{' '}
                                <a href="mailto: support.inst@santec.com"> support.inst@santec.com</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="logo">
                    <a href="https://inst.santec.com" target="_blank" rel="noreferrer noopener">
                        <img src="/images/santec_logo_stacked_gray.svg" alt="JGR logo" />
                    </a>
                </div>
            </div>
        );
    }
}

export default AboutPage;
